import { Component, Input } from '@angular/core';

import { PcvizEstimationCost } from '@mirage-projects/cw-models';

/**
 * This component tells the user the processing costs for the operation and its current credits
 */
@Component({
    selector: 'cw-estimation-credits',
    templateUrl: 'estimation-credits.component.html',
    styleUrls: ['./estimation-credits.component.scss'],
    standalone: false,
})
export class EstimationCreditsComponent {
    /** The credits remaining when processing is done */
    @Input() creditsAfterProcessing?: number;
    /** The value of user's credit after the process completed. */
    @Input() availableCredits?: number;

    processingTime?: Date;

    private _estimation?: PcvizEstimationCost;

    /** An object containing credit information. */
    @Input()
    set estimation(value: PcvizEstimationCost | undefined) {
        this._estimation = value;

        if (this._estimation?.processingTime) {
            this.processingTime = new Date(0, 0, 0);
            this.processingTime.setSeconds(this._estimation?.processingTime);
        }
    }

    /* istanbul ignore next*/
    get estimation(): PcvizEstimationCost | undefined {
        return this._estimation;
    }
}
